<template>
  <div id="app">
    <router-view ref="headerView" name="headerView"></router-view>
    <router-view ref="headerMenuView" name="headerMenuView"></router-view>
    <router-view></router-view>
    <router-view ref="footerView" name="footerView"></router-view>
  </div>
</template>

<script>
  import { provide, getCurrentInstance, reactive } from "vue";

  export default {
    name: "Root",
    setup() {
      const instance = getCurrentInstance();

      // Access global $menuState from globalProperties, or create a fallback
      // This ensures $root.hideMenu() and inject('menuState') use the same state
      const globalProps = instance.appContext.config.globalProperties;
      const menuState = globalProps.$menuState || reactive({ displayMenu: false });

      // Menu control methods that modify the global state
      const showMenu = () => {
        menuState.displayMenu = true;
      };

      const hideMenu = () => {
        menuState.displayMenu = false;
      };

      const toggleMenu = () => {
        menuState.displayMenu = !menuState.displayMenu;
      };

      // Provide to all descendant components (for HeaderMenuSection inject)
      provide("menuState", menuState);
      provide("showMenu", showMenu);
      provide("hideMenu", hideMenu);
      provide("toggleMenu", toggleMenu);

      // Expose axios request instance for $root.request compatibility
      // Components use this.$root.request.post(), etc.
      const request = globalProps.$request;

      // Expose messageCollection for $root.messageCollection compatibility
      // StatusMessage.vue uses this.$root.messageCollection[message]
      const messageCollection = globalProps.$messageCollection;

      return {
        request,
        messageCollection,
      };
    },
  };
</script>
